import { render, staticRenderFns } from "./infoData.vue?vue&type=template&id=279e21e4&scoped=true"
import script from "./infoData.vue?vue&type=script&lang=js"
export * from "./infoData.vue?vue&type=script&lang=js"
import style0 from "./infoData.vue?vue&type=style&index=0&id=279e21e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e21e4",
  null
  
)

export default component.exports